import { render, staticRenderFns } from "./GeneralInformationSection.vue?vue&type=template&id=f030b0e8&"
import script from "./GeneralInformationSection.vue?vue&type=script&lang=js&"
export * from "./GeneralInformationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports